import type { Entry } from 'contentful';

import { Layout, LayoutContainer, LayoutSection, TextLink, Icon } from '@petsmart-ui/sparky';
import { buildPage, ComponentResolver } from '../../utils';
import { Autocomplete } from '../Autocomplete';
import { HeaderDrawer } from '../HeaderDrawer';
import { Location } from '../Location';
import './Header.scss';
import MainMenuResolver from './MainMenuResolver';
import { StickyHeader } from './StickyHeader';
import type { HeaderProps } from './types';
import { UtilityIcons } from './UtilityIcons';
import { LogoWrapper } from '../LogoWrapper';
import { Locale, getLocale } from '@libs/core';

export default function Header({ entry }: HeaderProps) {
    if (!entry) {
        return null;
    }

    const { mainMenu, livesSaved, items, secondaryNavigation, onTopItems } = entry.fields;
    const children = buildPage(items as Entry[]);

    const isLocaleUs = getLocale() === Locale['en-US'];
    return (
        <>
            {children}
            <StickyHeader
                onTopItems={onTopItems as Entry[]}
                top={
                    <LayoutContainer>
                        <Layout breakLayout="slower" className="layout">
                            <LayoutSection className="upper-nav-container__left-section">
                                <ComponentResolver entry={livesSaved as Entry} />
                                <Location />
                            </LayoutSection>
                            <LayoutSection className="upper-nav-container__secondary-link-section">
                                {/* <ComponentResolver entry={secondaryNavigation as Entry} /> */}
                                <TextLink href="/treats-rewards">
                                    Treats Rewards
                                    <Icon name="treats-fill" size="sm" />
                                </TextLink>
                                <TextLink href="/gift-cards/">Gift Cards</TextLink>
                                <TextLink href="/learning-center/">Learning Center</TextLink>
                                <TextLink
                                    href={
                                        isLocaleUs ? 'https://petsmartcharities.org/' : 'https://petsmartcharities.ca/'
                                    }
                                >
                                    PetSmart Charities
                                </TextLink>
                                <TextLink href="/featured-shops/auto-ship">Autoship</TextLink>
                            </LayoutSection>
                        </Layout>
                    </LayoutContainer>
                }
                middle={
                    <LayoutContainer className="middle-header-container">
                        <HeaderDrawer secondaryNavigation={secondaryNavigation as Entry} mainMenu={mainMenu as Entry} />

                        <LogoWrapper className="c-global-header__logo" />

                        <MainMenuResolver mainMenu={mainMenu as Entry} />

                        <Autocomplete className="velocity-autocomplete" productsHitPerPage={3} />

                        <UtilityIcons />
                    </LayoutContainer>
                }
            />
        </>
    );
}
